import { AlpineComponentTryba } from '../../scripts/alpine/include/global';
import { activateAbTestByEvent } from '../../scripts/ab/registry';

// AB test 86c5m05un - Link to quotation form with prefilled steps
export default (): AlpineComponentTryba => ({
    init() {
        window.addEventListener('ab-quotation-cp-step', () => {
            activateAbTestByEvent('ab-quotation-cp-step');
            this.$store.ab.skipCPstepState = true;
        })
    },
});
